import { AgCharts } from "ag-charts-react";
const Chart = ({ options }: any) => {
  return <AgCharts options={options}/>;
};

export default Chart;